import { createSimpleStore } from '@passionware/simple-store';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { NavigateFunction } from './NavigationService';
import { createNavigationService } from './NavigationService.impl';

const navigateFunctionNoop = {
  navigate: () => {
    throw new Error('Navigation function not injected');
  }
};

const navigateFunctionStore = createSimpleStore<{ navigate: NavigateFunction }>(
  navigateFunctionNoop
);

export const myNavigationService = createNavigationService({
  navigateFunctionStore
});

export function NavigationServiceInjector(props: { children: ReactNode }) {
  const { push, replace } = useHistory();
  const nav: NavigateFunction = (to, options) => {
    if (options?.replace) {
      replace(to);
    } else {
      push(to);
    }
  };
  if (navigateFunctionStore.getCurrentValue() === navigateFunctionNoop) {
    navigateFunctionStore.setNewValue({ navigate: nav });
  }
  return props.children;
}
